export default "__VITE_ASSET__DqM7r$Sv__"